//@flow
import * as actions from './actions'
import Api from 'utils/api'
import config from 'config'

export const checkAuth = () => async (
  dispatch: Function,
  getState: Function,
) => {
  dispatch(actions.checkAuth())
  if (getState().auth.isLoggedIn) return
  try {
    const user: Object = await Api.request(
      `/users/me?app=${config.redirectUri}`,
      {},
      config.ssoUri,
    )
    dispatch(actions.signIn(user))
  } catch (err) {
    const { redirect_to } = await err.json()
    if (redirect_to) {
      window.location = config.ssoUri + redirect_to
    }
    dispatch(actions.signInError())
  }
}

export const logOut = () => async (dispatch: Function): Promise<any> => {
  dispatch(actions.logOutRequest())
  try {
    const response = await Api.request(
      '/logout',
      { method: 'DELETE' },
      config.redirectUri,
    )
    dispatch(actions.logOutSuccess())
    sessionStorage.clear()
    window.location.reload()
    return Promise.resolve(response)
  } catch (err) {
    dispatch(actions.logOutError())
    return Promise.reject(err)
  }
}

export const fetchUserCompany = () => async (dispatch: Function) => {
  dispatch(actions.fetchUserCompanyRequest())
  try {
    const company: Object = await Api.request('/users/me/company')
    dispatch(actions.fetchUserCompanySuccess(company))
  } catch (err) {
    dispatch(actions.fetchUserCompanyError())
  }
}
